export const EXTERNAL_REPORT_TYPE = 'emergency-response-team';
